import { useState } from 'react';

export const DocumentView = ({
	frontImage,
	backImage,
}: {
	backImage: string;
	frontImage: string;
}) => {
	const [isError, setIsError] = useState({
		front: false,
		back: false,
	});

	// GUARD ON THE VALUE, not only on a load error.
	//
	// A SINGLE-SIDED document (a passport) legitimately has no back image:
	// kyc.api stores `backImage: {value: null}` on purpose. Rendering the <img>
	// anyway gave it no `src`, and an <img> WITHOUT a src never fires `error` --
	// so the onError guard below could never hide it. The result was a broken-
	// image placeholder sitting next to a perfectly good passport scan on every
	// passport session, plus a dead click target that called window.open(undefined).
	//
	// This mirrors the truthiness guards already used for the same markup in
	// views/transactions/components/sender-details.tsx.
	return (
		<div className="kycDetails-info__documentView_inner">
			{!!frontImage && !isError.front && (
				<div className="kycDetails-info__documentView_inner_img">
					<img
						src={frontImage}
						alt="pic"
						onClick={() => window.open(frontImage)}
						onError={() => {
							setIsError(prev => ({ ...prev, front: true }));
						}}
					/>
				</div>
			)}
			{!!backImage && !isError.back && (
				<div className="kycDetails-info__documentView_inner_img">
					<img
						src={backImage}
						alt="pic"
						onClick={() => window.open(backImage)}
						onError={() => {
							setIsError(prev => ({ ...prev, back: true }));
						}}
					/>
				</div>
			)}
		</div>
	);
};
